export const getSparePartIdFromBarcode = (barcode: string): string | undefined => {
  const array = barcode.split('/');

  if (array.length < 2) {
    return;
  }

  return array.pop();
};
